import { isFeatureEnabled } from 'owa-feature-flags';
import { getUserConfiguration } from 'owa-session-store';
import { isDeepLink } from 'owa-url';

/**
 * Checks whether Todo Panel feature is available in current user/window context.
 */
export function isTodoPanelAvailable(): boolean {
    if (isDeepLink() && window.opener) {
        return false;
    }
    return (
        isFeatureEnabled('todo-panel') &&
        !isFeatureEnabled('cal-time-panel') &&
        !getUserConfiguration().SessionSettings.IsShadowMailbox
    );
}
